import { call, put, takeEvery } from 'redux-saga/effects';
import { gcApi } from 'config/axios';

import { FETCH_TYPED_SPLITS, FETCH_TYPED_SPLITS_SUCCESS, FETCH_TYPED_SPLITS_FAIL } from 'actions/ActionTypes.js';

export function* fetchTypedSplitsSaga(action) {
    try {
        const response = yield call(gcApi.get, `/activity-service/activity/${action.activityId}/typedsplits`);

        yield put({
            type: FETCH_TYPED_SPLITS_SUCCESS,
            typedSplits: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_TYPED_SPLITS_FAIL,
            typedSplits: []
        });
    }
}

export const typedSplits = [takeEvery(FETCH_TYPED_SPLITS, fetchTypedSplitsSaga)];
